<template>
  <b-modal
    ref="modal"
    title="刪除週期性預約"
    @hidden="handleCancel"
    @ok="handleConfirm"
    ok-title="確認刪除"
    ok-variant="danger"
    cancel-title="取消"
    :ok-disabled="loading"
    :cancel-disabled="loading"
    :no-close-on-backdrop="loading"
    :no-close-on-esc="loading"
  >
    <p class="mb-3">
      請選擇刪除範圍：
    </p>

    <b-form-group>
      <b-form-radio-group v-model="scope" stacked>
        <label class="mutation-scope">
          <b-form-radio value="this">
            <div>
              <strong>這次預約</strong>
              <p class="mutation-scope__note">只修改選定日期的預約</p>
            </div>
          </b-form-radio>
        </label>
        <label class="mutation-scope">
          <b-form-radio value="future">
            <div>
              <strong>這次預約與後續預約</strong>
              <p class="mutation-scope__note">修改選定日期及之後的所有預約</p>
            </div>
          </b-form-radio>
        </label>
        <label class="mutation-scope">
          <b-form-radio value="all">
            <div>
              <strong>所有預約</strong>
              <p class="mutation-scope__note">修改此週期性預約所有尚未開始的預約記錄</p>
            </div>
          </b-form-radio>
        </label>
      </b-form-radio-group>
    </b-form-group>

    <div v-if="previewDates.length" class="mt-3">
      <h6>將被刪除的預約：</h6>
      <ul class="list-unstyled preview-list">
        <li v-for="(dateRange, index) in previewDates" :key="index" class="mb-2">
          <i class="fa fa-calendar text-danger"></i>
          <span v-if="dateRange.end">
            {{ formatDate(dateRange.start) }} ~ {{ formatDate(dateRange.end) }}
          </span>
          <span v-else>
            {{ formatDate(dateRange.start) }}
          </span>
        </li>
      </ul>
      <p v-if="previewDates.length >= 5" class="text-muted small">
        * 僅顯示前 5 筆預約
      </p>
    </div>

    <div v-if="loading" class="text-center mt-3">
      <b-spinner small></b-spinner>
      <span class="ml-2">處理中...</span>
    </div>
  </b-modal>
</template>

<script>
import { previewDatesForExisting } from '@/utils/periodicBookingHelper';
import moment from 'moment';

export default {
  name: 'ScopeDeleteModal',
  data() {
    return {
      scope: 'this',
      loading: false,
      periodicBooking: null,
      targetDate: null
    };
  },
  computed: {
    showDatePicker() {
      return this.scope === 'this' || this.scope === 'future';
    },
    previewDates() {
      if (!this.periodicBooking || !this.targetDate) {
        return [];
      }

      // Construct effective start_at for the target date occurrence
      const originalStartMoment = moment(this.periodicBooking.start_at);
      const effectiveStartAt = moment(this.targetDate)
        .hour(originalStartMoment.hour())
        .minute(originalStartMoment.minute())
        .second(originalStartMoment.second())
        .format('YYYY-MM-DD HH:mm:ss');

      return previewDatesForExisting({
        ...this.periodicBooking,
        start_at: effectiveStartAt
      }, this.scope, 5);
    }
  },
  methods: {
    show(periodicBooking, targetDate) {
      this.periodicBooking = periodicBooking;
      this.targetDate = targetDate;
      this.scope = 'this';
      this.$refs.modal.show();
    },
    handleConfirm(bvModalEvt) {
      bvModalEvt.preventDefault();

      if (this.loading) return;

      this.$emit('confirm', {
        scope: this.scope,
        target_date: this.targetDate,
        periodicBooking: this.periodicBooking
      });
    },
    hide() {
      this.$refs.modal.hide();
    },
    setLoading(isLoading) {
      this.loading = isLoading;
    },
    handleCancel() {
      this.scope = 'this';
      this.periodicBooking = null;
      this.targetDate = null;
      this.$refs.modal.hide();
    },
    formatDate(date) {
      return moment(date).format('YYYY-MM-DD HH:mm');
    }
  }
};
</script>

<style lang="scss" scoped>
.mutation-scope {
  display: block;
  background-color: #f4f4f4;
  border-radius: 8px;
  padding: 16px;
  cursor: pointer;
  transition: all .3s;

  & + & {
    margin-top: 8px;
  }

  &:hover {
    background-color: #e8e8e8;
  }

  * {
    cursor: pointer;
  }

  &__note {
    margin: 0;
    font-size: 12px;
    color: #666;
  }
}

.preview-list {
  background-color: #fff3cd;
  border: 1px solid #ffc107;
  border-radius: 4px;
  padding: 12px 16px;
  max-height: 300px;
  overflow-y: auto;

  li {
    padding: 4px 0;

    i {
      margin-right: 8px;
    }
  }
}
</style>
